module.exports = __webpack_public_path__ + "static/rockin_logo.7856b430.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/rockin_logo.png
// module id = 3192
// module chunks = 173905520285976